/* eslint-disable */
import AddressTypeahead from '@loggi/ui/components/address-typeahead';
import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Display from '@loggi/ui/components/display';
import Icon from '@loggi/ui/components/icon';
import LoaderMask from '@loggi/ui/components/loader-mask';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import privatePackageTrackerModel from 'app.models';
import getStatusPath from 'app/app.utils';
import classNames from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { fetchQuery, graphql } from 'react-relay';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import AddressComplement from 'shared/address-complement/address-complement.component';
import {
  CATEGORY_NAME,
  EDIT_ADDRESS_TYPEAHEAD
} from 'shared/analytics/analytics.constants';
import sendGoogleAnalyticsDataEvent from 'shared/analytics/analytics.utils';
import MainView from 'shared/main-view/main-view.component';
import MapBackground from 'shared/map-background/map-background.component';
import environment from 'shared/relay/environment';
import * as appActions from 'tracker.actions';
import { CONFIRM_ADDRESS } from 'tracker.routes';
import styles from './edit-address.styles.scss';

export const ALERT_TYPEAHEAD_TEXT = {
  ADDRESS_WITHOUT_NUMBER: 'Você precisa informar um número',
  ADDRESS_WITHOUT_DESTINATION_INFO: {
    TITLE: 'Endereço fora da área de cobertura.',
    CONTENT:
      'Para receber seu pedido nesse endereço, fale com a loja onde você fez a compra. Ou tente outro endereço para ver se está na nossa abrangência.'
  },
  ADDRESS_NUMBER_DONT_EXIST: 'O número selecionado não existe'
};

export class EditAddressContainer extends Component {
  static displayName = 'EditAddressContainer';

  static propTypes = {
    privatePackageTracker: PropTypes.shape(privatePackageTrackerModel)
      .isRequired,
    newDestinationInfo: PropTypes.shape(
      privatePackageTrackerModel.destinationInfo
    ),
    newComplement: PropTypes.string
  };

  static defaultProps = {
    privatePackageTracker: {},
    newDestinationInfo: null,
    newComplement: null
  };

  constructor(props) {
    super(props);
    const {
      privatePackageTracker,
      newDestinationInfo,
      newComplement,
      match: {
        params: { packageId }
      }
    } = props;
    this._removeDefaultAlertAddressTypeaheadComponent = this._removeDefaultAlertAddressTypeaheadComponent.bind(
      this
    );
    this._customTypeaheadSuggestionContainer = this._customTypeaheadSuggestionContainer.bind(
      this
    );
    this._onAddressSelected = this._onAddressSelected.bind(this);
    this._onClickStepBack = this._onClickStepBack.bind(this);
    this._goToConfirmNewAddress = this._goToConfirmNewAddress.bind(this);
    this._renderValue = this._renderValue.bind(this);

    this.addressTypeahead = React.createRef();

    this.state = {
      complement:
        newComplement ||
        get(privatePackageTracker, 'destinationInfo.complement', ''),
      lat: get(
        newDestinationInfo,
        'coordinates.lat',
        get(privatePackageTracker, 'destinationInfo.coordinates.lat', 0)
      ),
      lng: get(
        newDestinationInfo,
        'coordinates.lng',
        get(privatePackageTracker, 'destinationInfo.coordinates.lng', 0)
      ),
      firstLine: get(
        newDestinationInfo,
        'firstLine',
        get(privatePackageTracker, 'destinationInfo.firstLine', '')
      ),
      firstRender: true,
      isLoading: !privatePackageTracker.hasOwnProperty('destinationInfo'),
      addressHasDestinationInfo: true,
      addressHasError: false,
      statusPath: getStatusPath(packageId),
      newComplement: null
    };
  }

  componentDidUpdate() {
    // Way to remove the default alert element from Elke AddressTypeahead Component
    this._removeDefaultAlertAddressTypeaheadComponent();

    // Way to custom typeaheadSuggestionContainer layout
    this._customTypeaheadSuggestionContainer();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const destinationInfoUpdated =
      this.state.firstLine !== nextState.firstLine ||
      this.state.lat !== nextState.lat ||
      this.state.lng !== nextState.lng;

    const queryReturnsNull =
      this.state.addressHasDestinationInfo !==
      nextState.addressHasDestinationInfo;

    const addressAlert =
      this.state.addressHasError !== nextState.addressHasError;

    if (addressAlert) {
      return true;
    }

    if (destinationInfoUpdated) {
      this.setState({
        firstLine: nextState.firstLine,
        firstRender: false,
        addressHasDestinationInfo: true
      });

      return true;
    }

    if (queryReturnsNull) {
      return true;
    }

    return false;
  }

  _onSuccessToGetNewDestinationInfo = newDestinationInfo => {
    const {
      privatePackageTracker,
      history,
      actions: { savePrivatePackageTracker, saveNewPackageAddress }
    } = this.props;
    const { addressData, newComplement } = this.state;

    savePrivatePackageTracker({
      privatePackageTracker
    });

    saveNewPackageAddress({
      addressData,
      newDestinationInfo,
      newComplement
    });

    const event = {
      categoryName: CATEGORY_NAME.EDIT_ADDRESS,
      action: EDIT_ADDRESS_TYPEAHEAD.FULL_ADDRESS.SUCCESS.ACTION,
      label: EDIT_ADDRESS_TYPEAHEAD.FULL_ADDRESS.SUCCESS.LABEL
    };
    sendGoogleAnalyticsDataEvent(event);

    return history.push(CONFIRM_ADDRESS);
  };

  _getNewDestinationInfo(callFetchQuery) {
    const query = graphql`
      query editAddressTypeaheadQuery(
        $packageId: Int!
        $addressData: AddressData!
      ) {
        privatePackageTrackerAddressValidation(
          packageId: $packageId
          addressData: $addressData
        ) {
          firstLine
          secondLine
          coordinates {
            lat
            lng
          }
        }
      }
    `;
    const { addressData } = this.state;
    const { packageId } = this.props.match.params;

    this.setState({ isLoading: true });

    callFetchQuery(environment, query, {
      packageId: Number(packageId),
      addressData
    })
      .then(response => {
        this.setState({ isLoading: false });
        if (!response.privatePackageTrackerAddressValidation.firstLine) {
          const event = {
            categoryName: CATEGORY_NAME.EDIT_ADDRESS,
            action: EDIT_ADDRESS_TYPEAHEAD.FULL_ADDRESS.FAILURE.ACTION,
            label: EDIT_ADDRESS_TYPEAHEAD.FULL_ADDRESS.FAILURE.LABEL
          };
          sendGoogleAnalyticsDataEvent(event);
          return this.setState({ addressHasDestinationInfo: false });
        }
        this._onSuccessToGetNewDestinationInfo(
          response.privatePackageTrackerAddressValidation
        );
      })
      .catch(() => {
        return this.setState({
          isLoading: false,
          addressHasDestinationInfo: false
        });
      });
  }

  _removeDefaultAlertAddressTypeaheadComponent() {
    const defaultAlertTypeaheadIcon = ReactDOM.findDOMNode(
      this.addressTypeahead.current
    ).getElementsByClassName('ico-alert')[0];

    if (defaultAlertTypeaheadIcon) {
      const defaultAlertTypeaheadText =
        defaultAlertTypeaheadIcon.parentNode.nextSibling;

      defaultAlertTypeaheadIcon.classList.add(
        styles.removeDefaultAlertTypeahead
      );
      defaultAlertTypeaheadText.classList.add(
        styles.removeDefaultAlertTypeahead
      );
    }
  }

  _customTypeaheadSuggestionContainer() {
    const typeaheadSuggestionContainer = ReactDOM.findDOMNode(
      this.addressTypeahead.current
    ).getElementsByTagName('UL')[0];

    if (typeaheadSuggestionContainer) {
      typeaheadSuggestionContainer.classList.add(
        styles.customTypeaheadSuggestionContainer
      );
    }
  }

  _onAddressSelected(addressData) {
    const {
      geometry: {
        location: { lat, lng }
      }
    } = addressData;

    // Fix addressData from Google response for using in the mutation
    addressData.geometry.location = {
      lat: lat(),
      lng: lng()
    };
    addressData.geometry.viewport = {};
    addressData.geometry.bounds = {};

    this.setState({
      lat: lat(),
      lng: lng(),
      addressData
    });
  }

  _onClickStepBack() {
    const pathname = get(this, 'props.pathname', false);
    if (pathname) {
      return this.props.history.replace(pathname);
    }
    const { statusPath } = this.state;
    return this.props.history.replace(statusPath);
  }

  _hasAddressChanged = () => {
    const { privatePackageTracker } = this.props;
    const lat = get(
      privatePackageTracker,
      'destinationInfo.coordinates.lat',
      0
    );
    const lng = get(
      privatePackageTracker,
      'destinationInfo.coordinates.lng',
      0
    );

    const { addressData } = this.state;

    return (
      addressData &&
      (get(addressData, 'geometry.location.lat', lat) !== lat ||
        get(addressData, 'geometry.location.lng', lng) !== lng)
    );
  };

  _goToConfirmOnlyNewComplement = newComplement => {
    const {
      privatePackageTracker,
      history,
      actions: { savePrivatePackageTracker, saveNewPackageAddress }
    } = this.props;
    savePrivatePackageTracker({
      privatePackageTracker
    });
    saveNewPackageAddress({
      newComplement
    });
    const event = {
      categoryName: CATEGORY_NAME.EDIT_ADDRESS,
      action: EDIT_ADDRESS_TYPEAHEAD.COMPLEMENT.ACTION,
      label: EDIT_ADDRESS_TYPEAHEAD.COMPLEMENT.LABEL
    };
    sendGoogleAnalyticsDataEvent(event);
    history.push(CONFIRM_ADDRESS);
  };

  _goToConfirmNewAddress(newComplement) {
    const { privatePackageTracker, history, actions } = this.props;
    const { complement } = this.state;

    const hasAddressChanged = this._hasAddressChanged();

    const hasComplementChanged = newComplement.trim() !== complement.trim();

    if (!hasAddressChanged && !hasComplementChanged) {
      // Redirect to the next screen without address changes
      actions.savePrivatePackageTracker({
        privatePackageTracker
      });
      return history.push(CONFIRM_ADDRESS);
    }

    if (hasAddressChanged && hasComplementChanged) {
      // Call a query to get the new destination info and
      // redirect to the next screen with the new address and complement
      return this.setState({ newComplement }, () => {
        this._getNewDestinationInfo(fetchQuery);
      });
    }

    if (hasAddressChanged) {
      // Call a query to get the new destination info and
      // redirect to the next screen with ONLY the new address
      return this._getNewDestinationInfo(fetchQuery);
    }

    if (hasComplementChanged) {
      // Redirect to the next screen with ONLY the new complement
      return this.setState({ newComplement }, () => {
        this._goToConfirmOnlyNewComplement(newComplement);
      });
    }
  }

  _renderValue(value) {
    if (!value && this.state.firstRender) {
      return this.state.firstLine;
    }

    this.setState({ firstLine: value });

    return value;
  }

  _onChange = data => {
    if (!data) {
      this.setState({ addressHasError: true });
    } else {
      this.setState({ addressHasError: false });
    }
  };

  _addressWithoutNumberMessage() {
    return (
      <React.Fragment>
        <Icon type={icons.type.INFO} color="yellow-700" />
        <Text small bold color="yellow-700">
          {ALERT_TYPEAHEAD_TEXT.ADDRESS_WITHOUT_NUMBER}
        </Text>
      </React.Fragment>
    );
  }

  _addressOutOfRangeMessage() {
    return (
      <React.Fragment>
        <Icon type={icons.type.INFO} color={colors.type.DANGER} />
        <Text bold small color={colors.type.DANGER}>
          {ALERT_TYPEAHEAD_TEXT.ADDRESS_WITHOUT_DESTINATION_INFO.TITLE}
        </Text>
        <Text small color={colors.type.DANGER}>
          {ALERT_TYPEAHEAD_TEXT.ADDRESS_WITHOUT_DESTINATION_INFO.CONTENT}
        </Text>
      </React.Fragment>
    );
  }

  _addressHasErrorMessage() {
    return (
      <React.Fragment>
        <Icon type={icons.type.INFO} color={colors.type.DANGER} />

        <Text small color={colors.type.DANGER}>
          {ALERT_TYPEAHEAD_TEXT.ADDRESS_NUMBER_DONT_EXIST}
        </Text>
      </React.Fragment>
    );
  }

  render() {
    const {
      complement,
      lat,
      lng,
      firstLine,
      addressHasDestinationInfo,
      addressHasError,
      statusPath
    } = this.state;

    const {
      privatePackageTracker,
      history: {
        location: { search }
      }
    } = this.props;
    const queryString = search;

    if (
      !privatePackageTracker ||
      !privatePackageTracker.hasOwnProperty('destinationInfo')
    ) {
      if (queryString) {
        return <Redirect to={`${statusPath}${queryString}`} />;
      }

      return <Redirect to={statusPath} />;
    }

    const classesWrap = classNames(
      styles.addressTypeaheadContainer,
      'pin-to-top'
    );

    const _addressWithoutNumber = firstLine.includes('número');
    const _shouldRenderAlertAddressTypeahead =
      _addressWithoutNumber || !addressHasDestinationInfo || addressHasError;
    const _shouldRenderAddressComplement = !_shouldRenderAlertAddressTypeahead;

    return (
      <MainView className="tracker-content">
        <Display when={this.state.isLoading}>
          <LoaderMask />
        </Display>
        <Display when={!this.state.isLoading}>
          <MapBackground lat={lat} lng={lng} />
          <View className={classesWrap}>
            <Col
              backgroundColor={colors.type.ACTIVE}
              className={styles.hideInputBorder}
            >
              <View className={styles.addressTypeaheadHeader}>
                <Button
                  data-testid="back-btn"
                  style="link"
                  icon={icons.type.BACK}
                  onClick={this._onClickStepBack}
                />
                <Col size={10}>
                  <AddressTypeahead
                    inputProps={{
                      'data-hj-whitelist': true,
                      type: 'text'
                    }}
                    ref={this.addressTypeahead}
                    onAddressSelected={this._onAddressSelected}
                    renderValue={this._renderValue}
                    onChange={this._onChange}
                  />
                </Col>
              </View>
            </Col>
            {_shouldRenderAlertAddressTypeahead && (
              <Col
                className={styles.customAlertAddressTypeahead}
                gutter={{
                  top: 'normal',
                  bottom: 'normal',
                  left: 'onehalf',
                  right: 'double'
                }}
                flexDirection="column"
                alignItems="start"
              >
                {_addressWithoutNumber && this._addressWithoutNumberMessage()}

                {!addressHasDestinationInfo && this._addressOutOfRangeMessage()}
                {addressHasError &&
                  !_addressWithoutNumber &&
                  this._addressHasErrorMessage()}
              </Col>
            )}
            {_shouldRenderAddressComplement && (
              <Col gutter={{ left: 'normal', right: 'normal' }}>
                <AddressComplement
                  complement={complement}
                  onClick={this._goToConfirmNewAddress}
                  buttonValue="Continuar"
                />
              </Col>
            )}
          </View>
        </Display>
      </MainView>
    );
  }
}

function mapStateToProps(state) {
  return {
    privatePackageTracker: state.data.privatePackageTracker,
    pathname: state.data.pathname,
    newDestinationInfo: state.packageAddress.newDestinationInfo,
    newComplement: state.packageAddress.newComplement
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAddressContainer);
